import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AdminError from '../../../components/admin/admin-error';
import AdminTextInput from '../../../components/admin/admin-text-input.js';
import MediaUploader from '../../../components/multipleMedia/MediaUploader.js';
import { marketPlaceItem } from './marketPlaceItem';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { showLoading, hideLoading } from '../../../store/loading-reducer';
import { submitMarketPlace, getMarketPlaceByIdEdit } from '../../../api/marketPlace';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { useAdminMenuContext } from "../../../context/AdminMenuContext";
import { getMarketPlaceTypes } from '../../../store/marketPlace/actions';

const ckEditorConfig = {
    toolbar: [
        'Bold',
        'Italic',
        'Link',
        'Unlink',
        'NumberedList',
        'BulletedList',
        'doclibrary'
    ],
    link: {
        decorators: {
            openInNewTab: {
                mode: 'manual',
                label: 'Open in a new tab',
                attributes: {
                    target: '_blank',
                    rel: 'noopener noreferrer'
                }
            },
        },
        addTargetToExternalLinks: true,
        defaultProtocol: 'http://',
        validate: function (url) {

            return /^(?:(?:https?|ftp):\/\/)?(?:\/)?(?:[^@\n]+@)?(?:www\.)?[^.]+\.[^.]+/.test(url);
        },
    },
    image: {
        resizeOptions: false,
        toolbar: []
    }
};

const FileRepository = {
    createUploadAdapter: (loader) => {
        return new UploadAdapter(loader);
    },
};
class UploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }
    upload() {
        return new Promise((resolve) => {
            const imageUrl = this.loader.data;
            resolve({ default: imageUrl });
        });
    }
}

export function AddEditMarketPlace() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [error, setError] = useState('');
    const { marketPlaceTypesList } = useSelector(state => state.marketPlace);
    const [marketPlace, setMarketPlace] = useState(marketPlaceItem);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [mediaItems, setMediaItems] = useState([]);
    const { marketplaceBaseId } = useParams();
    const [publishDateInputValue, setPublishDateInputValue] = useState(marketPlace?.publishDate ? new Date(marketPlace.publishDate) : new Date());
    const [editLink, setEditLink] = useAdminMenuContext('');
    useEffect(() => {
        if (marketplaceBaseId > 0) {
            dispatch(showLoading());
            getMarketPlaceByIdEdit(marketplaceBaseId).then((response) => {
                let marketPlaceResponse = response.data.data;
                if (marketPlaceResponse?.amountType?.length > 23) {
                    marketPlaceResponse.amountType = marketPlaceResponse.amountType.substring(0, 23);
                }
                setMarketPlace(marketPlaceResponse);
                setPublishDateInputValue(marketPlaceResponse?.publishDate ? new Date(marketPlaceResponse.publishDate) : new Date());
                if (marketPlaceResponse.media !== null && marketPlaceResponse.media.length > 0) {
                    var getMediaItems = [];
                    marketPlaceResponse.media.forEach((item) => {
                        item.mediaItem.mediaId = item.mediaId;
                        getMediaItems.push(item.mediaItem);
                    });
                    setMediaItems(getMediaItems);
                }
                setEditLink(`/marketplace-details/${marketplaceBaseId}`);
                console.log(editLink)
            }).catch((error) => {
                console.error("Error fetching marketplace:", error);
            }).finally(() => {
                dispatch(hideLoading());
            });
        }
        else {
            setEditLink('');
        }

    }, []);


    const [validation, setValidation] = useState({
        marketPlaceTitle: true,
        marketPlaceAuthor: true,
        marketPlaceType: true
    });

    useEffect(() => {
        document.title = 'Market Place  | CWP Employee Portal';
        dispatch(getMarketPlaceTypes());
    }, []);

    const handleMarketPlaceSave = () => {
        dispatch(showLoading());
        var isValid = true;

        let validate = {
            marketPlaceTitleError: '',
            marketPlaceTypeError: '',
            marketPlaceAuthorError: '',

        };
        if (marketPlace == null || marketPlace.title == null || marketPlace.title == "") {
            validate.marketPlaceTitle = false;
            validate.marketPlaceTitleError = "Title is required";
            isValid = false;
        }
        if (marketPlace == null || marketPlace.author == null || marketPlace.author == "") {
            validate.marketPlaceAuthor = false;
            validate.marketPlaceAuthorError = "Author is required";
            isValid = false;
        }
        if (!marketPlace.marketPlaceTypeId || marketPlace.marketPlaceTypeId === 0) {
            validate.marketPlaceType = false;
            validate.marketPlaceTypeError = "Type is required";
            isValid = false;
        }

        setValidation({ ...validation, ...validate });
        if (isValid == false) {
            dispatch(hideLoading());
            return;
        }
        submitMarketPlace(marketPlace)
            .then((response) => {
                if (response.data.success == false) {
                    dispatch(hideLoading());
                    setError(response.data.message);
                    return;
                }
                if (response.data.success) {
                    dispatch(hideLoading());
                    navigate('/siteadmin/marketplace');
                }
            })
            .catch((err) => {
                dispatch(hideLoading());
                if (err.response.data && err.response.data.message) {
                    setError(err.response.data.message);
                } else {
                    setError(err.response.responseText);
                }
            });
    };

    const handleMediaUpdates = (mediaItems) => {
        setMarketPlace({
            ...marketPlace,
            media: mediaItems,
        });
    };


    const handleDateFormate = (date) => {
        const inputDate = date;
        let formattedDate = inputDate.replace(/\D/g, ''); // Remove all non-digit characters
        if (formattedDate.length > 2 && formattedDate.length <= 4) {
            formattedDate = formattedDate.slice(0, 2) + '/' + formattedDate.slice(2);
        } else if (formattedDate.length > 4) {
            formattedDate = formattedDate.slice(0, 2) + '/' + formattedDate.slice(2, 4) + '/' + formattedDate.slice(4, 8);
        }
        return formattedDate;
    };

    const isValidDateFormat = (dateString) => {
        // Define a regular expression pattern for the desired format (mm/dd/yyyy)
        const dateFormatPattern = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

        // Check if the dateString matches the pattern
        return dateFormatPattern.test(dateString);
    }

    const publishDateDateChange = (event) => {
        if (event.type === "change") {
            const formattedDate = handleDateFormate(event.target.value);
            setPublishDateInputValue(formattedDate);
            if (isValidDateFormat(formattedDate)) {
                setMarketPlace({ ...marketPlace, publishDate: new Date(formattedDate) });
            }
        }
    };

    const handlePaste = (event, editor, data) => {
        event.stop();

        // Get plain text from clipboard
        const plainText = data.dataTransfer.getData('text/plain');

        // Insert plain text at the current selection/cursor
        editor.model.change((writer) => {
            // Remove any selection and insert plain text
            writer.insertText(plainText, editor.model.document.selection.getFirstPosition());
        });

        // Update your state with the new content (plain text)
        const updatedContent = editor.getData();

        setMarketPlace((prevEvent) => ({ ...prevEvent, content: updatedContent }));
        setIsInitialLoad(false);
    };
    const handleMarketPlaceType = (e) => {
        const selectedType = parseInt(e.target.value);
        setMarketPlace({ ...marketPlace, marketPlaceTypeId: selectedType });
    };
    return (
        <div className="admin-page-wrap">
            <div className="admin-top-bar-wrap">
                <div className="admin-top-bar-left">
                    <Link
                        className="admin-top-bar-back"
                        to={'/siteadmin/marketplace'}
                    >
                        Back
                    </Link>
                </div>
            </div>
            <div className="admin-page-content">
                <h1 className="admin-page-heading">Add/Edit Market Place</h1>
                <AdminError
                    message={error}
                    onClose={() => {
                        setError('');
                    }}
                ></AdminError>
                <div className="admin-section admin-section-narrow">
                    <div className="admin-section-row">
                        <div className="admin-section-cell">
                            <label className="admin-radio-label inline label-nowrap">
                                <input
                                    className="admin-inline-checkbox"
                                    type="radio"
                                    id="Publish"
                                    name="visibility"
                                    checked={marketPlace.visibility === 0}
                                    onChange={() => setMarketPlace({ ...marketPlace, visibility: 0 })}
                                />
                                Publish
                            </label>
                        </div>
                        <div className="admin-section-cell">
                            <label className="admin-radio-label inline">
                                <input
                                    className="admin-inline-checkbox"
                                    type="radio"
                                    id="Unpublish"
                                    name="visibility"
                                    checked={marketPlace.visibility === 2}
                                    onChange={() => setMarketPlace({ ...marketPlace, visibility: 2 })}
                                />
                                Unpublish
                            </label>
                        </div>
                        <div className="admin-section-cell">
                            <label className="admin-radio-label inline label-nowrap">
                                <input
                                    className="admin-inline-checkbox"
                                    type="radio"
                                    id="Sold"
                                    name="visibility"
                                    checked={marketPlace.visibility === 3}
                                    onChange={() => setMarketPlace({ ...marketPlace, visibility: 3 })}
                                />
                                Sold
                            </label>
                        </div>
                    </div>

                    <div className="admin-section-row">
                        <div className="admin-section-cell wide">
                            <AdminTextInput
                                label="Title"
                                id="title-marketplace"
                                value={marketPlace?.title ?? ''}
                                isRequired={true}
                                onChange={(value) => {
                                    setMarketPlace({ ...marketPlace, title: value });
                                    setValidation({ ...validation, marketPlaceTitle: value != '' });
                                }}
                                validated={validation.marketPlaceTitle}
                                requiredText={validation.marketPlaceTitleError}
                            />
                        </div>
                    </div>
                    <div className="admin-section-row">
                        <div className={`admin-section-cell wide ${!validation.marketPlaceType ? 'input-validation-error' : ''}`}>
                            <label className="admin-default-label">
                                Type
                            </label>
                            <select className="admin-default-select" onChange={handleMarketPlaceType} value={marketPlace.marketPlaceTypeId}>
                                <option value="0" disabled hidden > Please Select a Type </option>
                                {marketPlaceTypesList
                                    .map((marketPlaceType) =>
                                        <option key={marketPlaceType.id} value={marketPlaceType.id}>
                                            {marketPlaceType.name}
                                        </option>
                                    )
                                }
                            </select>

                            {!validation.marketPlaceType && (
                                <p className="input-validation-error"><span className="validation-error-message">{validation.marketPlaceTypeError}</span></p>
                            )}
                        </div>
                        <div className="admin-section-cell wide">
                            <AdminTextInput
                                label="Author"
                                id="author-marketplace"
                                value={marketPlace?.author ?? ''}
                                isRequired={true}
                                onChange={(value) => {
                                    setMarketPlace({ ...marketPlace, author: value });
                                    setValidation({ ...validation, marketPlaceAuthor: value != '' });
                                }}
                                validated={validation.marketPlaceAuthor}
                                requiredText={validation.marketPlaceAuthorError}
                            />
                        </div>
                    </div>
                    <div className="admin-section-row">
                        <div className="admin-section-cell wide">
                            <AdminTextInput
                                label="Amount Bold Text"
                                id="AmountInfo-marketplace"
                                value={marketPlace?.amountInfo ?? ''}
                                onChange={(value) => {
                                    setMarketPlace({ ...marketPlace, amountInfo: value });

                                }}
                            />
                        </div>
                        <div className="admin-section-cell wide">
                            <AdminTextInput
                                label="Detail Sub Heading"
                                id="detail-subheading-marketplace"
                                value={marketPlace?.amountType ?? ''}
                                onChange={(value) => {
                                    if (value.length <= 23) {
                                        setMarketPlace({ ...marketPlace, amountType: value });
                                    }

                                }}
                            />
                            <span className={`character-counter`}> {23 - (marketPlace?.amountType?.length ?? 0)}/23 characters remaining </span>
                        </div>
                    </div>
                    <div>
                        <div className="admin-section-row">
                            <div className="admin-section-cell wide">
                                <AdminTextInput
                                    label="Location"
                                    id="location-marketplace"
                                    value={marketPlace?.location ?? ''}
                                    onChange={(value) => {
                                        setMarketPlace({ ...marketPlace, location: value });

                                    }}
                                />
                            </div>
                            <div className="admin-section-cell wide">
                                <label className="admin-default-label">Publish Date</label>
                                <DatePicker
                                    className="admin-default-input-text"
                                    selected={marketPlace?.publishDate ? new Date(marketPlace.publishDate) : new Date()}
                                    placeholder="mm/dd/yyyy"
                                    autoComplete="off"
                                    onChange={(date) => {
                                        setMarketPlace({ ...marketPlace, publishDate: date });
                                    }}
                                    onChangeRaw={publishDateDateChange}
                                    value={publishDateInputValue}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="admin-section-row circle">
                        <div className="admin-section-cell full">
                            <p className="admin-section-small-headline">Image/Video</p>
                            <MediaUploader
                                isPlaceHolder={false}
                                requireAltText={false}
                                imageOnly={false}
                                videoOnly={false}
                                forceCrop={false}
                                allowGallery={true}
                                mediaItems={mediaItems}
                                saveMediaItems={handleMediaUpdates}
                                allowSorting={true}
                                sortInTable="MarketPlaceMedia"
                            />
                        </div>
                    </div>

                    <div className="admin-section-row">
                        <div
                            className={
                                'admin-section-cell extra-wide'
                            }
                        >
                            <label className="admin-default-label" htmlFor="short-desc">
                                Content
                            </label>
                            <CKEditor
                                editor={Editor}
                                config={ckEditorConfig}
                                data={marketPlace && marketPlace.content || ''}
                                onReady={(editor) => {
                                    editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
                                        FileRepository.createUploadAdapter(loader);

                                    // Listen for the clipboardInput event to intercept paste
                                    editor.editing.view.document.on('clipboardInput', (evt, data) => {
                                        handlePaste(evt, editor, data);
                                    });
                                }}
                                onChange={(marketPlace, editor) => {
                                    const data = editor.getData();
                                    setMarketPlace((prevMarketPlace) => ({ ...prevMarketPlace, content: data }));
                                    if (!isInitialLoad) {
                                        console.log("data", data);
                                    }
                                    setIsInitialLoad(false);
                                }}
                                onPaste={handlePaste}
                            />
                        </div>
                    </div>

                    <div className="admin-section-row">
                        <div className="admin-section-cell wide">
                            <label className="admin-default-label" htmlFor="WaterMark-marketplace">WaterMark</label>
                            <textarea
                                className="admin-default-textarea "
                                id="WaterMark-marketplace"
                                value={marketPlace?.waterMark ?? ''}
                                onChange={(e) => {
                                    setMarketPlace({ ...marketPlace, waterMark: e.target.value });
                                }}
                                rows="2"
                            />
                        </div>
                    </div>
                </div>

                <div className="admin-floating-button-wrap">
                    <button
                        className="admin-floating-button"
                        onClick={() =>
                            navigate('/siteadmin/marketplace')
                        }
                    >
                        Cancel
                    </button>
                    <button
                        className="admin-floating-button power"
                        onClick={handleMarketPlaceSave}
                    >
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
} 